import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router , ActivatedRoute} from '@angular/router';
import { SDGComponent, Result, ResultData, QuestionCategoryGroup, QuestionCategoryType, QuestionType } from '../../_models/index';
import { AlertService, SDGComponentService, ResultService } from '../../_services/index';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import * as $ from 'jquery';

var COMPONENT = environment.component.resilience;

@Component({
  selector: 'app-resilience-data',
  templateUrl: './resilience-data.component.html',
  styleUrls: ['./resilience-data.component.css']
})

export class ResilienceDataComponent implements OnInit, OnDestroy {
  sdgcomponent$ : Observable<SDGComponent>;
  results$ : Observable<ResultData[]>;
  subscription1:Subscription;
  subscription2:Subscription;
  qcgroups : Array<QuestionCategoryGroup>=[];
  qctypes : Array<QuestionCategoryType>=[];
  qtypes : Array<any>=[];
  rows: Array<Object>=[];
  rowsobj: Object;
  qtindexobj: Object;
  qtindexrevarr: Array<Object>;
  qtypes_new : Array<any>=[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sdgComponentService: SDGComponentService,
    private alertService: AlertService,
    private resultService: ResultService) { }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".resilience-click").addClass("header_active")

    this.results$ = this.resultService.getResultData(COMPONENT);
    this.sdgcomponent$ = this.sdgComponentService.getAll(COMPONENT);
    this.subscription1 = this.sdgcomponent$.subscribe( data => {
          var qtindex = 0;
          var qtindexobj = {};
          var qtindexrevarr = [];
          var qct = data['question_category_type'];
          this.qctypes = Array.apply(null, Array(qct.length)).map(function () {});

          //create an array of question category types using order as array index
          for (var i=0; i < qct.length; i++){
            var span = qct[i].question_type.length;
            if(qct[i].average)
              span += 1;
            if(qct[i].positive_response_percent)
              span += 1;
            this.qctypes[qct[i].order-1] = {"name":qct[i].name,"span":span,"question_type":qct[i].question_type,
              "category_group":qct[i].category_group, "order":qct[i].order,
              "average": qct[i].average, "positive_response_percent": qct[i].positive_response_percent }
          }
          //Remove the last element
          this.qctypes.splice(-1,1);

          //create an array of question category type groups
          var qcgroup=this.qctypes[0].category_group;
          var groupspan=0;
          for (var i=0; i < this.qctypes.length; i++){
            if(this.qctypes[i].category_group == qcgroup){
              groupspan += this.qctypes[i].span;
            }
            else{
              this.qcgroups.push({"name":qcgroup,"span":groupspan});
              qcgroup = this.qctypes[i].category_group;
              groupspan = this.qctypes[i].span;
            }
          }
          this.qcgroups.push({"name":qcgroup,"span":groupspan});

          //create an array of question types using order as array index going through all qctypes and all qtypes within each qctype
          for (var i=0; i < this.qctypes.length; i++){

            var qctypeobj = this.qctypes[i];
            var qtarr :any = this.qctypes[i].question_type;

            //create an array of qtypes in one qctype
            var arr = Array.apply(null, Array(qtarr.length)).map(function () {});
            for (var j=0; j < qtarr.length; j++)
              arr[qtarr[j].order-1] = {id:qtarr[j].id,"name":qtarr[j].name,order:qtarr[j].order,display_text:qtarr[j].display_text};

            //add above qtypes into the lookup table for qtypeid => qtypeindex (column order)
            //and reverse lookup columnorder => qtype
            for (var k=0; k < arr.length; k++){
              this.qtypes.push(arr[k]);
              qtindexobj[arr[k].id] = qtindex;
              qtindexrevarr[qtindex] = arr[k].name;
              qtindex++;
            }

            var dt='';
           // move qtindex forward to add columns for avearage and response if needed
           if(qctypeobj.average){
           if(qctypeobj.category_group=="Infrastructure")
             dt = "Average score: Infrastructure hazard level assessed AND infrastructure risk zone level";
             this.qtypes.push({id:0,"name":"Average",order:this.qtypes[this.qtypes.length-1].order, display_text: dt});
             qtindexrevarr[qtindex] = "Average";
             qtindex++;
           }
            if(qctypeobj.positive_response_percent){
            if(qctypeobj.category_group=="Disaster Risk Reduction Strategies")
              dt = "Proportion of positive responses for 'DRR Strategies'";
            if(qctypeobj.category_group=="Disaster Risk Information and Assessments")
              dt = "Proportion of positive responses for 'Risk Information and Assessments'";
              this.qtypes.push({id:0,"name":"+ve Response %",order:this.qtypes[this.qtypes.length-1].order, display_text: dt});
              qtindexrevarr[qtindex] = "Response";
              qtindex++;
            }
          }
          this.qtindexobj = qtindexobj;
          this.qtindexrevarr = qtindexrevarr;

          var ctar = data['category'];
          var rows = {};
          var row = {};
          function label_name(ct){
            return ct.name.replace("Target ","").replace("Indicator ","");
          }
          for (var c = 0; c < ctar.length; c++){
            var ct = ctar[c];
            row["catname"] = label_name(ct);
            var scl = ct.sub_category.length;
            row["rowspan"] = scl;
            var catrow1 = true;
            for (var sc = 0; sc < scl; sc++){
              var newrow = {catname:row["catname"], rowspan:row["rowspan"]};
              var sct = ct.sub_category[sc];
              newrow["subcatname"] = label_name(sct);
              newrow["catrow"] = catrow1;
              if(sct.order == 2)
                newrow["rowspan"] = 0;
              catrow1 = false;
              var resultsarr = Array.apply(null, Array(qtindex)).map(function () {});
              newrow["resultsarr"] = resultsarr;
              rows[sct.id] = newrow;
            }
          }
          this.rowsobj = rows;
          this.subscription2 = this.results$.subscribe( data => {
                for(var i=0;i<data.length;i++){
                  var res = data[i];
                  var colidx = this.qtindexobj[res.question_type];
                  this.rowsobj[res.sub_category].resultsarr[colidx] = res;
                }
                //go through each row
                var data_valid;
                for(var ri in this.rowsobj){
                  data_valid = true;
                  var rowresults = this.rowsobj[ri].resultsarr;
                  var qcat_count = 0, weight_sum = 0, all_3 = true, none_1 = false, count_1 = 0;
                  var count_yes=0, count_unknown=0, count_non_empty = 0, r11_value=0, r12_value=0;
                  var curr_qcat_name = '';
                  //go through each result in the row
                  for(var rri = 0; rri < rowresults.length; rri++){
                    var resobj = rowresults[rri];
                    if(resobj)
                      curr_qcat_name = resobj.question_category_group;
                    if(curr_qcat_name == 'Disaster Risk Reduction Strategies'){
                      count_non_empty++;
                      if(resobj && resobj.value=='Unknown'){//if qtype is none of these
                        count_unknown++;
                      }
                      else if(resobj && resobj.value=='Yes'){//if qtype is none of these
                        count_yes++;
                      }
                      else if (this.qtindexrevarr[rri] == 'Response'){
                        //var avg_weight = weight_sum/qcat_count;
                        var avg_value;
                        if(count_unknown==7)
                          avg_value = 9999;
                        else
                          {avg_value = count_yes/(count_non_empty-1);
                          avg_value*=100;}
                        rowresults[rri] = {value:Math.round(avg_value) + "%"};
                        count_unknown=0;
                        count_yes=0;
                        count_non_empty=0;
                      }
                    }
                    else if(curr_qcat_name == 'Disaster Risk Information and Assessments'){
                      count_non_empty++;
                      if(resobj && resobj.value=='Unknown'){//if qtype is none of these
                        count_unknown++;
                      }
                      else if(resobj && resobj.value=='Yes'){//if qtype is none of these
                        count_yes++;
                      }
                      else if (this.qtindexrevarr[rri] == 'Response'){
                        //var avg_weight = weight_sum/qcat_count;
                        var avg_value;
                        if(count_unknown==3)
                          avg_value = 9999;
                        else
                          {avg_value = count_yes/(count_non_empty-1);
                            avg_value*=100;}
                        rowresults[rri] = {value:Math.round(avg_value) + "%"};
                        count_unknown=0;
                        count_yes=0;
                        count_non_empty=0;
                      }
                    }
                    else if(curr_qcat_name == 'Infrastructure'){
                      count_non_empty++;
                      if(resobj && resobj.question_type_name=='r11'){//if qtype is none of these
                        r11_value=Number(resobj.value);
                      }
                      else if(resobj && resobj.question_type_name=='r12'){//if qtype is none of these
                        r12_value=Number(resobj.value);
                      }
                     else if (this.qtindexrevarr[rri] == 'Average'){
                       avg_value = ((r11_value)+r12_value)/2;
                       rowresults[rri] = {value:avg_value.toFixed(0) + "%"};
                     }
                    }
                  }
                  for(var rri = 0; rri < rowresults.length; rri++){
                    if(!rowresults[rri])
                      rowresults[rri]="not entered";
                      //data_valid = false;
                  }
                  if(data_valid)
                  //Add new average column (i.e last column) in specified location (i.e 14) then remove last element
                    this.rowsobj[ri].resultsarr.splice(14, 0 , this.rowsobj[ri].resultsarr[18]);
                    this.rowsobj[ri].resultsarr.splice(-1,1)
                    debugger;
                    this.rows.push(this.rowsobj[ri]);
                }

this.qtypes_new = [
{'display_text':'1. Have National DRR strategies been adopted and implemented in line with the Sendai Framework for DRR 2015-2030?',
'min_col_width':10},
{'display_text':'2. Have climate change adaption and/or DRR been integrated into national development planning relevant to this target?',
'min_col_width':10},
{'display_text':'3. Are there national financing mechanisms for DRR relevant for this target?',
'min_col_width':10},
{'display_text':'4. Are lead agencies conducting (independent) periodic outcome reviews of the implementation of national and local DRR strategies relevant to this target?',
'min_col_width':10},
{'display_text':'5. Have sector specific DRR strategies been adopted and implemented  in line with the Sendai Framework for DRR?',
'min_col_width':10},
{'display_text':'6. Have cross-sectoral bodies/forums been formed that have  clear roles and responsibilities identified across state institutions, civil society, private sector and international actors , for the implementation and review of DRR measures for this target?',
'min_col_width':10},
{'display_text':'7. Do lead agencies have spatial and land use planning mechanisms for DRR?',
'min_col_width':10},
{'display_text':'Proportion of positive responses for \'DRR Strategies\'',
'min_col_width':10},
{'display_text':'8. Are multi-hazard national risk assessments or information available, with results in an accessible, understandable and usable format  for stakeholders and the public?',
'min_col_width':10},
{'display_text':'9. Do lead agencies for this target have  open data policies and mechanisms to make hazard and risk data accessible and available to all users',
'min_col_width':10},
{'display_text':'10. Does the lead agency for this target run  programmes to enhance awareness, disaster risk information and risk assessment?',
'min_col_width':10},
{'display_text':'Proportion of positive responses for \'Risk Information and Assessments\'',
'min_col_width':10},
{'display_text':'11. What proportion of state and private critical infrastructure are located in high hazard/disaster risk areas?',
'min_col_width':10},
{'display_text':'12. What proportion of state and private critical  infrastructure have Hazard, Risk and Vulnerability Analysis (or other risk  assessments) completed?',
'min_col_width':10},
{'display_text':'Infrastructural assessment',
'min_col_width':10},
{'display_text':'13. Have lead agencies for this target adopted and implemented relevant critical infrastructure protection plans?',
'min_col_width':10},
{'display_text':'14. What is the predicted economic loss, based on risk assessments completed, due to damage or destruction of critical infrastructure from disaster impact?',
'min_col_width':10},
{'display_text':'15. Has funding been allocated towards post-disaster infrastructure reconstruction?',
'min_col_width':10},
{'display_text':'16. What amount of funding is allocated towards post-disaster infrastructure reconstruction for this target?',
'min_col_width':10}];
for(var i=0;i<this.qtypes_new.length;i++)
this.qtypes_new[i].min_col_width = parseInt((this.qtypes_new[i].display_text.length*1.5).toFixed(0));

              },
              error => {
                this.alertService.error(error);
              });
        },
        error => {
          this.alertService.error(error);
        });
  }

empty_objects(objects_arrays){
  for (var j=0; j<objects_arrays.length; j++){
    var props = Object.getOwnPropertyNames(objects_arrays[j]);
    for (var i = 0; i < props.length; i++) {
      delete objects_arrays[j][props[i]];
    }
  }
}

ngOnDestroy() {
  //  used in template
  this.qcgroups = null;
  this.qctypes = null;
  this.qtypes = null;
  this.rows = null;

  if(this.subscription1)
    this.subscription1.unsubscribe();
  if(this.subscription2)
    this.subscription2.unsubscribe();
}

  resilientBtnClick(){
    this.router.navigateByUrl('/sdg/resilience')
  }
  quesBtnClick(){
    this.router.navigateByUrl('/sdg/resilience-quest')
  }
  dataBtnClick(){
    this.router.navigateByUrl('/sdg/resilience-data')
  }
  reportBtnClick(){
    this.router.navigateByUrl('/sdg/resilience-report')
  }
}



// WEBPACK FOOTER //
// ./src/app/sdg/resilience-data/resilience-data.component.ts